import { ChangeDetectionStrategy, Component, Input, OnInit, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { ConfigurationService, CoursesService, PathsService, PortalConfigurationService, UrlService } from '@draeger-academy/common';
import { LocalizeRouterService } from '@gilsdav/ngx-translate-router';
import { Course } from 'models/course';
import { TranslateService } from '@ngx-translate/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment as env, environment } from '../../../../../src/environments/environment';
import { GenericModalService } from '../generic-modal/services/generic-modal.service';
import { Router } from '@angular/router';
import { CartService } from '@draeger-academy/common/lib/services/cart/cart.service';

@Component({
    selector: 'da-course-teaser',
    templateUrl: './course-teaser.component.html',
    styleUrls: ['./course-teaser.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CourseTeaserComponent implements OnInit {
    public longDescription: SafeHtml;
    @Input() course: Course = null;
    @Input() mediaLeft = false;
    @Input() template = '';
    public language: string;
    public dynamicParameter: string;
    public courseDetail: any;
    public courseBooking: any;
    public courseImage: string;
    public alt = '';
    public isNew = false;
    public isBestSeller = false;
    public isWebinar = false;
    public isAdditionalKeyword = false;
    public isBookedCourse = false;
    public isOnlineCourse = false;
    public isPortal = false;
    public isPlusPortSite = false;
    @Input() public showBookingBtn = false;
    @Input() public showDetailsBtn = false;
    @Input() public showDemoBtn = false;
    public courseTitle = '';
    public lastWord = '';
    @ViewChild('warnWishlist', { static: true }) private _warnWishlist;
    @ViewChild('notTheSameCurrencyModal', { static: true }) private _notTheSameCurrencyModal;
    public site: string;

    public durationDays: number;
    public durationTime: number;
    public clickAddToCart = false;
    public currencyIsTheSameLikeOtherCourses: boolean;

    private _$courseImage: BehaviorSubject<{}> = new BehaviorSubject<{}>(null);
    private _$translations: BehaviorSubject<any> = new BehaviorSubject({});

    public get courseImage$(): Observable<{}> {
        return this._$courseImage.asObservable();
    }

    private _$course: BehaviorSubject<Course> = new BehaviorSubject<Course>(null);

    public get course$(): Observable<Course> {
        return this._$course.asObservable();
    }

    private _$showCartUpdate: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showCartUpdate$(): Observable<boolean> {
        return this._$showCartUpdate.asObservable();
    }

    private _modalId: string;
    @ViewChild('iframe', { static: true }) private _iframe;
    @ViewChild('overlay', { static: true }) private _overlay;
    @ViewChild('warn', { static: true }) private _warn;
    currency: string;

    private _$showCategories: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showCategories$(): Observable<boolean> {
        return this._$showCategories.asObservable();
    }

    private _$showDuration: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showDuration$(): Observable<boolean> {
        return this._$showDuration.asObservable();
    }

    private _$showCartUpdatePrebooking: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showCartUpdatePrebooking$(): Observable<boolean> {
        return this._$showCartUpdatePrebooking.asObservable();
    }

    private _$showVat: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showVat$(): Observable<boolean> {
        return this._$showVat.asObservable();
    }

    private _$showLabels: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showLabels$(): Observable<boolean> {
        return this._$showLabels.asObservable();
    }

    private _$showShortDesc: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showShortDesc$(): Observable<boolean> {
        return this._$showShortDesc.asObservable();
    }

    private _$pricePattern: BehaviorSubject<string> = new BehaviorSubject('');
    public get pricePattern$(): Observable<string> {
        return this._$pricePattern.asObservable();
    }
    private _$formattedPrice: BehaviorSubject<string> = new BehaviorSubject('');
    public get formattedPrice$(): Observable<string> {
        return this._$formattedPrice.asObservable();
    }
    private _$formattedPrice2: BehaviorSubject<string> = new BehaviorSubject('');
    public get formattedPrice2$(): Observable<string> {
        return this._$formattedPrice2.asObservable();
    }

    constructor(
        private _translateService: TranslateService,
        private _genericModalService: GenericModalService,
        private _configurationService: ConfigurationService,
        private _localizeRouterService: LocalizeRouterService,
        private _router: Router,
        private _urlService: UrlService,
        private _cartService: CartService,
        private _pathsService: PathsService,
        private _portalConfigurationService: PortalConfigurationService,
        private _coursesService: CoursesService
    ) {
        this._translateService.get('language').subscribe((res: string) => {
            this.language = res;
        });
    }

    ngOnInit() {
        this.site = this._configurationService.getCurrentSite();
        if (this._configurationService.isPartnerPage()) {
            this.isPortal = true;
        }
        this.checkIfItIsPlusPortSite();
        document.documentElement.scrollTop = 0;
        if (this.course) {
            if (this.course.unicodeTitle && this.course.unicodeTitle !== null && this.course.unicodeTitle !== '') {
                this.courseTitle = this.course.unicodeTitle;
            } else {
                this.courseTitle = this.course.name;
            }
            this._$course.next(this.course);
            this.currency = this._coursesService.getCurrencies(this.course, this.site);
            this.formatingPrice()
        }

        const ID = sessionStorage.getItem(`myCourseID`);

        if (ID === this.course.id) {
            this.isBookedCourse = true;
        } else {
            this.isBookedCourse = false;
        }

        if (this.course.isProduct) {
            this.isOnlineCourse = true;
        } else {
            this.isOnlineCourse = false;
        }

        this.courseBooking = this._pathsService.getBookingLink(this.course.id);
        this.courseDetail = this._pathsService.getCourseDetailLink(this.course.id);
        if (this.course.image && this.course.image.uri) {
            this.courseImage = env.APIEndpoint + this.course.image.uri.substr(this.course.image.uri.indexOf('/') + 1);
            this.courseImage = encodeURI(this.courseImage);
            this._$courseImage.next(this.courseImage);
            if (this.course.image && this.course.image.fileName) {
                this.alt = this.course.image.fileName;
            }
        }

        if (this._configurationService.hasFeature('Categories')) {
            this._$showCategories.next(true);
        }

        if (this._configurationService.hasFeature('Duration')) {
            this._$showDuration.next(true);
        }

        if (this._configurationService.hasFeature('ShowVATPrice')) {
            this._$showVat.next(true);
        }

        if (this._configurationService.hasFeature('ShortDescription')) {
            this._$showShortDesc.next(true);
        }

        this._translateService.get('keyWords'.toLowerCase()).subscribe((data) => {
            this._$translations.next(data);
        });

        if (this.course.keyWords) {
            if (this.course.keyWords && this.course.keyWords.length > 0) {
                const newLabel = this._$translations.getValue().new ? this._$translations.getValue().new : 'Neu';
                if (this.course.keyWords[0].toUpperCase() === newLabel.toUpperCase()) {
                    this.isNew = true;
                }

                const bestseller = this._$translations.getValue().bestseller ? this._$translations.getValue().bestseller : 'Bestseller';
                if (this.course.keyWords[0].toUpperCase() === bestseller.toUpperCase()) {
                    this.isBestSeller = true;
                }

                const webinar = this._$translations.getValue().webinar ? this._$translations.getValue().webinar : 'Webinar';
                if (this.course.keyWords[0].toUpperCase() === webinar.toUpperCase()) {
                    this.isWebinar = true;
                }
                this.isAdditionalKeyword = !this.isNew && !this.isBestSeller && !this.isWebinar ? true : false;
            }
        }
        if (this.course) {
            if (this.course.unicodeTitle && this.course.unicodeTitle !== null && this.course.unicodeTitle !== '') {
                this.courseTitle = this.course.unicodeTitle;
            } else {
                this.courseTitle = this.course.name;
            }
        }

        if (this.course.keyWords && this.course.keyWords.length > 0) {
            this._$showLabels.next(true);
            const words = this.courseTitle.split(' ');
            const lastStr = words[words.length - 1];
            this.lastWord = lastStr;
            words.pop();
            this.courseTitle = words.join(' ');
        }
    }

    public openOverlay(course: Course): void {
        this._overlayHandler();

        setTimeout(() => {
            const iframe = document.getElementById('demo');
            if (iframe) {
                iframe.setAttribute('src', environment.APIEndpoint + course.demo.uri);
            }
        }, 0);
    }

    private async _overlayNotification() {
        this._$showCartUpdate.next(true);
        setTimeout(() => this._$showCartUpdate.next(false), 4000);
    }

    public goToCart() {
        this._$showCartUpdate.next(false);
        this.closeModal();
        this._cartService.goToCart();
    }

    public addCourseToCart() {
        let _site = this._configurationService.getCurrentSite();
        if (this._configurationService.isPartnerPage()) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }
        this.clickAddToCart = true;
        this._cartService.ordersent = false;

        this.currencyIsTheSameLikeOtherCourses = this._configurationService.checkIfCurrencyIsDifferentToCartItemsCurrency(
            _site,
            this.currency
        );
        if (!this.currencyIsTheSameLikeOtherCourses) {
            this._overlayNotTheSameCurrency();
        } else {
            if (localStorage.getItem(`cartItems${_site}`)) {
                const cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site}`)));

                if (cartItems && cartItems.courses.filter((courseItem) => this.course.id === courseItem).length) {
                    if (this.clickAddToCart) {
                        this._overlayWarnHandler();
                    }
                } else {
                    this._cartService.addCourseToCart(this.course.id);
                    this._overlayNotification();
                }
            } else {
                this._cartService.addCourseToCart(this.course.id);
                this._overlayNotification();
            }
            this.clickAddToCart = false;
        }
    }

    private _overlayWarnWishlistHandler(): void {
        this._modalId = this._genericModalService.create(this._warnWishlist);
        this._genericModalService.open(this._modalId, this._warn, true);
    }

    public addToWishlist() {
        let _site = this._configurationService.getCurrentSite();
        if (this._configurationService.isPartnerPage()) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }
        this.clickAddToCart = true;
        this._cartService.ordersent = false;
        if (localStorage.getItem(`cartItems${_site}`)) {
            const cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site}`)));

            if (
                cartItems &&
                cartItems.courses &&
                cartItems.courses.filter((courseItem) => this.course.id === courseItem) &&
                cartItems.courses.filter((courseItem) => this.course.id === courseItem).length
            ) {
                if (this.clickAddToCart) {
                    this._overlayWarnWishlistHandler();
                }
            } else if (
                (cartItems &&
                    cartItems.wishlist &&
                    cartItems.wishlist.filter((courseItem) => this.course.id === courseItem) &&
                    cartItems.wishlist.filter((courseItem) => this.course.id === courseItem).length) ||
                (cartItems &&
                    cartItems.courses &&
                    cartItems.courses.filter((courseItem) => this.course.id === courseItem) &&
                    cartItems.courses.filter((courseItem) => this.course.id === courseItem).length)
            ) {
                this._overlayWarnHandler();
            } else {
                this._cartService.addCourseToWishlist(this.course.id);
                this._overlayNotificationPrebooking();
            }
        } else {
            this._cartService.addCourseToWishlist(this.course.id);
            this._overlayNotificationPrebooking();
        }
        this.clickAddToCart = false;
    }

    private _overlayHandler(): void {
        this._modalId = this._genericModalService.create(this._overlay);
        this._genericModalService.open(this._modalId, this._overlay, false, 'da-modal demo');
    }

    private _overlayWarnHandler(): void {
        this._modalId = this._genericModalService.create(this._warn);
        this._genericModalService.open(this._modalId, this._warn, true);
    }

    public closeModal() {
        if (this._modalId) {
            this._genericModalService.close(this._modalId);
        }
    }

    private async _overlayNotificationPrebooking() {
        this._$showCartUpdatePrebooking.next(true);
        setTimeout(() => this._$showCartUpdatePrebooking.next(false), 4000);
    }

    private _overlayNotTheSameCurrency(): void {
        this._modalId = this._genericModalService.create(this._notTheSameCurrencyModal);
        this._genericModalService.open(this._modalId, this._notTheSameCurrencyModal, true);
    }

    private formatingPrice(){      
        if (this._configurationService.isPartnerPage()) {
                this._portalConfigurationService.currencyPattern$.subscribe((currencyPattern) => {
                    this._$formattedPrice.next(this.formatPrice(this.course.prices[0].value, currencyPattern));
                    if (this.course.prices[1]){
                        this._$formattedPrice2.next(this.formatPrice(this.course.prices[1].value, currencyPattern));
                    }
                });

            this._translateService.stream('common').subscribe((translation) => {
                if (translation && translation.currency) {

                    if (translation.currency.ShowVATPrice === 'true') {
                        this._$showVat.next(true);
                    }
                }
            });
        } else {
            this._$pricePattern.next('#.##0,00 " $"');
            if (this.site === 'en_uk' || this.site === 'en_nz' || this.site === 'en_au' || this.site === 'fr_fr') {
                this._$pricePattern.next('#,##0.00 " $"');
            }

            if (this.course.prices.length > 0) {
                this._$formattedPrice.next(this.formatPrice(this.course.prices[0].value, this._$pricePattern.getValue()));
                if (this.course.prices[1]){
                    this._$formattedPrice2.next(this.formatPrice(this.course.prices[1].value, this._$pricePattern.getValue()));
                }
            } else {
                if (this.course.price){
                    this._$formattedPrice.next(this.formatPrice(this.course.price, this._$pricePattern.getValue()));
                }
            }           
            if (this._configurationService.hasFeature('ShowVATPrice')) {
                this._$showVat.next(true);
            }
        }
    }



    private formatPrice(price: any, formatPattern){
        if (formatPattern){
            return this._configurationService.formatPrice(price, formatPattern, this.currency);
        } else {
            return price;
        }
    }

    private checkIfItIsPlusPortSite() {
        if (!this.isPortal && (this.site === 'en_uk' || this.site === 'en_nz' || this.site === 'en_au' || this.site === 'fr_fr')) {
            this.isPlusPortSite = true;
        } else {
            this.isPlusPortSite = false;
        }
    }
}
